import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { masterData } from '../../../../api';

export const useInitializeMasterData = () => {
  const { entityRef, truckNumber } = useParams();
  const queryClient = useQueryClient();

  useQuery({
    queryKey: ['setup', entityRef],
    queryFn: async () => {
      const data = await masterData.getAllActiveMasterData({ entityRef, truckNumber });
      Object?.keys?.(data)?.forEach(key => {
        queryClient.setQueryData(['setup', entityRef, key], [].concat(data[key]));
      });
      return data;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
